var map = {
	"./screen1.png": 356,
	"./screen10.png": 357,
	"./screen2.png": 358,
	"./screen3.png": 359,
	"./screen4.png": 360,
	"./screen5.png": 361,
	"./screen6.png": 362,
	"./screen7.png": 363,
	"./screen8.png": 364,
	"./screen9.png": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 355;